/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Token names mapped to their values, used for contrast checking when generating custom themes
 *
 * @codegen <<SignedSource::9975d8c2d3b07e5b405782c2d24fab5f>>
 * @codegenCommand yarn build tokens
 */
var tokenValues = {
  'color.text.brand': '#0C66E4',
  'elevation.surface.sunken': '#F7F8F9',
  'color.background.selected': '#E9F2FF',
  'color.text.selected': '#0C66E4',
  'color.border.brand': '#0C66E4',
  'color.chart.brand': '#1D7AFC',
  'color.text.inverse': '#FFFFFF'
};
export default tokenValues;